import {
  getApiActionReducers,
  STATUS,
} from '@binotel-frontend/bnt-common-components';
import {createFeature, createReducer, on} from '@ngrx/store';

import {FavoritesActions} from './favorites.actions';
import {IFavoritesState} from './favorites-state.interface';

const favoritesFeatureKey = 'favoritesFeature';

const initialState: IFavoritesState = {
  favorites: null,
  favoritesLoadingStatus: STATUS.default,
};

const favoritesReducer = createReducer(
  initialState,
  ...getApiActionReducers<IFavoritesState>()(
    FavoritesActions.getFavorites,
    'favorites'
  ),
  on(FavoritesActions.clearFavorites, (): IFavoritesState => initialState)
);

export const favoritesFeature = createFeature({
  name: favoritesFeatureKey,
  reducer: favoritesReducer,
});
